"use strict";

define('model//paginate',['datakit/model'], function (Model) {
  var Paginate = Model.extend({
    defaults: {
      size: 25,
      page: 1
    },
    toJSON: function toJSON() {
      var data = {};
      if (this.has(Paginate.SIZE)) {
        data.size = this.get(Paginate.SIZE);
      }
      if (this.has(Paginate.PAGE)) {
        data.page = this.get(Paginate.PAGE);
      }
      return data;
    }
  }, {
    PAGE: 'page',
    SIZE: 'size',
    TOTAL_PAGES: 'totalPages',
    TOTAL_ITEMS: 'totalElements'
  });
  return Paginate;
});

